"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memoize;

function memoize(func) {
  var hasher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (args) {
    return JSON.stringify(args);
  };

  var memoized = function memoized() {
    var cache = memoized.cache;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var address = "" + hasher.apply(this, args);
    if (!cache.hasOwnProperty(address)) cache[address] = func.apply(this, args);
    return cache[address];
  };

  memoized.cache = {};
  return memoized;
}

module.exports = exports.default;